"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.__usedConstrctionFunc = exports.constructLDFeatureSwitch = exports.withFeatureSwitch = void 0;
var react_1 = require("react");
var context_1 = require("./context");
var ldClient_1 = require("./ldClient");
var util_1 = require("./util");
var enhancer_1 = require("./enhancer");
/**
 *
 *
 * @template T
 * @param {string} clientSideId
 *  Launch darkly client side id
 * @param {T} [initialFeatureSwitches]
 *  Initial feature switches
 * @param {LDFeatureSwitchesConfig} [config={ hotReload: true, waitForReady: true }]
 *
 *  hotReload[default true]: if true, when receive feature flag change, will instantly update app
 *
 *  waitForReady[default true]: whether wait for launch darkly ready, usually it takes 200ms, according to launch darkly docs
 * @param {LDOptions} [ldClientOption]
 *  Launch darkly client options
 * @param {string} [userIdentifier]
 *  to setup launch darkly user
 * @return {*}  {Promise}
 */
var withFeatureSwitch = function (clientSideId, initialFeatureSwitches, config, ldClientOption, userIdentifier) {
    if (config === void 0) { config = {
        hotReload: true,
        waitForReady: true,
        showLog: false,
    }; }
    return __awaiter(void 0, void 0, void 0, function () {
        var ld, _initialFeatureSwitches;
        return __generator(this, function (_a) {
            ld = ldClient_1.FlagManager.init(clientSideId, { showLog: config.showLog }, ldClientOption, userIdentifier);
            _initialFeatureSwitches = util_1.validateFeatureSwitches(initialFeatureSwitches || {});
            return [2 /*return*/, enhancer_1.createEnhancer(ld, _initialFeatureSwitches, context_1.FeatureSwitchProvider, config)];
        });
    });
};
exports.withFeatureSwitch = withFeatureSwitch;
var __usedConstrctionFunc = false;
exports.__usedConstrctionFunc = __usedConstrctionFunc;
var DEFAULT_CONFIG = {
    hotReload: true,
    waitForReady: true,
    showLog: false,
    proxy: {
        enable: true,
        baseUrl: util_1.LAUNCH_DARKLY_PROXY_URL,
    },
};
var mixWithDefaultConfig = function (config) { return (__assign(__assign(__assign({}, DEFAULT_CONFIG), config), { proxy: __assign(__assign({}, DEFAULT_CONFIG.proxy), config.proxy) })); };
var constructLDFeatureSwitch = function (clientSideId, initialFeatureSwitches, _config, ldClientOption, userIdentifier) {
    var _a;
    exports.__usedConstrctionFunc = __usedConstrctionFunc = true;
    var config = mixWithDefaultConfig(_config);
    var proxyOptions = ((_a = config.proxy) === null || _a === void 0 ? void 0 : _a.enable)
        ? {
            baseUrl: config.proxy.baseUrl + "/app",
            eventsUrl: config.proxy.baseUrl + "/events",
        }
        : undefined;
    var ld = ldClient_1.FlagManager.init(clientSideId, { showLog: config.showLog }, __assign(__assign({}, proxyOptions), ldClientOption), userIdentifier);
    var _initialFeatureSwitches = util_1.validateFeatureSwitches(initialFeatureSwitches || {});
    var ctx = context_1.createContext();
    var Provider = ctx.Provider;
    var useFeatureFlag = function (featureName) {
        var featureSwitches = react_1.useContext(ctx).featureSwitches;
        return (featureSwitches === null || featureSwitches === void 0 ? void 0 : featureSwitches[featureName]) || false;
    };
    var useFeatureSwitches = function () {
        var featureSwitches = react_1.useContext(ctx).featureSwitches;
        return featureSwitches;
    };
    var useFeatureSwitchContext = function () {
        return react_1.useContext(ctx);
    };
    var useIdentifyUser = function () {
        var flagManager = react_1.useContext(ctx).flagManager;
        return function (userId) { return flagManager.identifyUser(userId); };
    };
    var enhancer = enhancer_1.createEnhancer(ld, _initialFeatureSwitches, Provider, config);
    return {
        enhancer: enhancer,
        FeatureSwitchContext: ctx,
        useFeatureFlag: useFeatureFlag,
        useFeatureSwitches: useFeatureSwitches,
        useFeatureSwitchContext: useFeatureSwitchContext,
        useIdentifyUser: useIdentifyUser,
    };
};
exports.constructLDFeatureSwitch = constructLDFeatureSwitch;
